__turbopack_context__.v({
  "additionalImages": "CmsRenderer-module-scss-module__ghaKeq__additionalImages",
  "buckleNotice": "CmsRenderer-module-scss-module__ghaKeq__buckleNotice",
  "debugIndex": "CmsRenderer-module-scss-module__ghaKeq__debugIndex",
  "debugLabel": "CmsRenderer-module-scss-module__ghaKeq__debugLabel",
  "debugNull": "CmsRenderer-module-scss-module__ghaKeq__debugNull",
  "debugType": "CmsRenderer-module-scss-module__ghaKeq__debugType",
  "debugWrapper": "CmsRenderer-module-scss-module__ghaKeq__debugWrapper",
  "detailsContainer": "CmsRenderer-module-scss-module__ghaKeq__detailsContainer",
  "gallery": "CmsRenderer-module-scss-module__ghaKeq__gallery",
  "gridImage": "CmsRenderer-module-scss-module__ghaKeq__gridImage",
  "imageGrid": "CmsRenderer-module-scss-module__ghaKeq__imageGrid",
  "info": "CmsRenderer-module-scss-module__ghaKeq__info",
  "productDetail": "CmsRenderer-module-scss-module__ghaKeq__productDetail",
  "productImage": "CmsRenderer-module-scss-module__ghaKeq__productImage",
  "sizeSelector": "CmsRenderer-module-scss-module__ghaKeq__sizeSelector",
  "strapDescription": "CmsRenderer-module-scss-module__ghaKeq__strapDescription",
  "warrantyBadge": "CmsRenderer-module-scss-module__ghaKeq__warrantyBadge",
  "warrantyContent": "CmsRenderer-module-scss-module__ghaKeq__warrantyContent",
  "warrantyInfo": "CmsRenderer-module-scss-module__ghaKeq__warrantyInfo",
  "warrantyLabel": "CmsRenderer-module-scss-module__ghaKeq__warrantyLabel",
  "warrantySection": "CmsRenderer-module-scss-module__ghaKeq__warrantySection",
  "warrantyText": "CmsRenderer-module-scss-module__ghaKeq__warrantyText",
  "warrantyYears": "CmsRenderer-module-scss-module__ghaKeq__warrantyYears",
});
